import { get, writable } from 'svelte/store';
import { navigate } from '../../../app.logic';
import { QualityMaintenanceScheduleService } from '../../../services/quality-maintenance-schedule.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    if (oid == 0) {
        record.set({ oid: 0, description: "", schedule: "", internal: 1, notes: "" });
    }
    else {
        let _resp = await QualityMaintenanceScheduleService.fetchQualityMaintenanceSchedule(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await QualityMaintenanceScheduleService.getQualityMaintenanceSchedules(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/quality-schedule-maintenance/0`);
}
export function onEdit(item) {
    navigate(`/quality-schedule-maintenance/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await QualityMaintenanceScheduleService.saveQualityMaintenanceSchedule(_record);
}
export async function onDelete(item) {
    await QualityMaintenanceScheduleService.deleteQualityMaintenanceSchedule(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
